<template>
    <div class="chip" :class="{'chip-outlined': type === 'outlined'}">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name:"BaseChip",
    props:{
        type:{
            type: String
        }
    }
}
</script>
<style scoped>
.chip {
    display: inline-block;
    color: #fff;
    font-size: 12px;
    padding: 3px 10px;
    justify-content: center;
    align-items: center;
    border-radius: 1000px;
    background: #004583;
    font-weight: 700;
    line-height: 18px;
}

.chip-outlined{
    color: #004583;
    background: #FFF;
    border: 1px solid #004583;
}
</style>